import React from 'react';
import { TwitterIcon, LinkedinIcon, AwardIcon, MailIcon, MapPinIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#0F1115] text-gray-400 border-t border-gray-800 relative overflow-hidden" data-id="element-32">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent opacity-50" data-id="element-33"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-35">
          {/* Brand */}
          <div className="space-y-6" data-id="element-36">
            <div className="flex items-center w-fit cursor-default" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/xoV8WdVtYH8fbNCxUxVcda/2.png" alt="CertifiedDevs" className="h-28 w-auto" data-id="element-38" />
            </div>
            <p className="text-base text-gray-400 leading-relaxed max-w-sm" data-id="element-39">
              The premier platform for connecting certified developers with top
              companies worldwide. We verify skills so you can hire with
              confidence.
            </p>
            <div className="flex gap-4 pt-2" data-id="element-40">
              <a href="https://x.com/certifieddevs" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#1a1d24] flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#d73b3e] transition-all duration-300 border border-gray-800 hover:border-[#d73b3e]" data-id="element-41">
                <TwitterIcon className="w-5 h-5" data-id="element-42" />
              </a>
              <a href="https://www.linkedin.com/company/certifieddevs" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#1a1d24] flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#0077b5] transition-all duration-300 border border-gray-800 hover:border-[#0077b5]" data-id="element-43">
                <LinkedinIcon className="w-5 h-5" data-id="element-44" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="md:text-right" data-id="element-45">
            <h3 className="text-white font-semibold mb-6 text-lg" data-id="element-46">
              Contact Us
            </h3>
            <ul className="space-y-4 text-sm inline-block text-left md:text-right" data-id="element-47">
              <li className="flex items-start gap-3 md:justify-end" data-id="element-48">
                <MailIcon className="w-5 h-5 text-[#d73b3e] mt-0.5 md:order-2" data-id="element-49" />
                <a href="mailto:contact@certifieddevs.com" className="hover:text-white transition-colors md:order-1" data-id="element-50">
                  contact@certifieddevs.com
                </a>
              </li>
              <li className="flex items-start gap-3 md:justify-end" data-id="element-51">
                <MapPinIcon className="w-5 h-5 text-[#d73b3e] mt-0.5 md:order-2" data-id="element-52" />
                <span className="md:order-1" data-id="element-53">
                  Rheastraat 35
                  <br data-id="element-54" />
                  1076DS Amsterdam
                  <br data-id="element-55" />
                  Netherlands
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-56">
          <p data-id="element-57">
            &copy; {new Date().getFullYear()} CertifiedDevs. All rights
            reserved.
          </p>
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-58">
            <p data-id="element-59">CertifiedDevs is part of W Consultants</p>
          </div>
        </div>
      </div>
    </footer>;
};